import React, { forwardRef, lazy, Suspense, useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { UserProvider } from "./context/user/userSettings";
import { getTokenFrom } from "./firebase"; // Updated import
import "react-notifications-component/dist/theme.css";
import { ReactNotifications } from "react-notifications-component";
import axios from "axios";
import { ApiEndpoint } from "config/constants/apiConstants";
import { authHeader } from "auth/authHeader";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { HelmetProvider } from "react-helmet-async";

import MenuBar from "components/common/navbar/MenuBar";
import DeedRoutes from "config/DeedRoutes";
import Footer from "components/common/Footer/Footer";

import {
  IS_CHRISTMAS,
  IS_SINHALA_TAMIL_NEW_YEAR,
} from "config/eventsUpdate/seasonal";

const App = forwardRef((props, ref) => {
  const [token, setTokenFound] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("../firebase-messaging-sw.js", { scope: "/app/" })
        .then((registration) => {
          getTokenFrom(setTokenFound, registration);
        })
        .catch((err) =>
          console.error("Service Worker Registration Failed:", err),
        );
    }
  }, []);

  const ChristmasDecor = lazy(
    () => import("components/events/seasonal/christmas"),
  );
  const SinhalaTamilNewYearDecor = lazy(
    () => import("components/events/seasonal/sinhalatamilnewyear"),
  );

  /*   useEffect(() => {
    if (token && token !== null) {
      axios
        .post(
          ApiEndpoint.REGISTER_DEVICE_TOKEN,
          { deviceType: "WEB", deviceToken: token },
          { headers: authHeader() }
        )
        .then((res) => console.log("Device Token Registered:", res.data))
        .catch((err) => console.error("Token Registration Error:", err));
    }
  }, [token]); */

  return (
    <HelmetProvider>
      <UserProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          {IS_CHRISTMAS && (
            <Suspense fallback={null}>
              <ChristmasDecor />
            </Suspense>
          )}

          {IS_SINHALA_TAMIL_NEW_YEAR && (
            <Suspense fallback={null}>
              <SinhalaTamilNewYearDecor />
            </Suspense>
          )}

          <MenuBar appNotifications={notification} />
          <ReactNotifications />
          <DeedRoutes />
          <Footer />
        </LocalizationProvider>
      </UserProvider>
    </HelmetProvider>
  );
});

export default App;
